import { render, staticRenderFns } from "./FormItemText.vue?vue&type=template&id=bf71c3b0&scoped=true&"
import script from "./FormItemText.vue?vue&type=script&lang=js&"
export * from "./FormItemText.vue?vue&type=script&lang=js&"
import style0 from "./FormItemText.vue?vue&type=style&index=0&id=bf71c3b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf71c3b0",
  null
  
)

export default component.exports